interface RankingItem {
  rank: number;
  title: string;
  author: string;
  heat: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const rankingItems: RankingItem[] = [
  {
    rank: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    heat: '1.28亿',
    tag: '热血玄幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20epic%20fantasy%20character%20with%20flames%20and%20energy%2C%20warm%20coral%20and%20golden%20amber%20tones%2C%20clean%20composition%20on%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail%2C%20shonen%20style&width=300&height=400&seq=rank-manga-01&orientation=portrait',
    imageAlt: '香香漫画 - 斗破苍穹封面',
  },
  {
    rank: 2,
    title: '一人之下',
    author: '米二',
    heat: '1.15亿',
    tag: '国漫之光',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20martial%20arts%20character%20with%20traditional%20Chinese%20elements%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20clean%20composition%20on%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail%2C%20seinen%20style&width=300&height=400&seq=rank-manga-02&orientation=portrait',
    imageAlt: '香香漫画 - 一人之下封面',
  },
  {
    rank: 3,
    title: '咒术回战',
    author: '芥见下下',
    heat: '1.02亿',
    tag: '暗黑奇幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20dark%20supernatural%20character%20with%20mystical%20energy%2C%20warm%20amber%20accents%20with%20deep%20shadows%2C%20clean%20composition%20on%20dark%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail&width=300&height=400&seq=rank-manga-03&orientation=portrait',
    imageAlt: '香香漫画 - 咒术回战封面',
  },
  {
    rank: 4,
    title: '仙王的日常生活',
    author: '枯玄',
    heat: '9600万',
    tag: '搞笑校园',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20comedy%20school%20life%20character%20with%20bright%20expression%2C%20warm%20coral%20and%20soft%20pink%20tones%2C%20clean%20composition%20on%20simple%20light%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail&width=300&height=400&seq=rank-manga-04&orientation=portrait',
    imageAlt: '香香漫画 - 仙王的日常生活封面',
  },
  {
    rank: 5,
    title: '海贼王',
    author: '尾田荣一郎',
    heat: '8900万',
    tag: '冒险经典',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20pirate%20adventure%20character%20with%20dynamic%20pose%2C%20warm%20coral%20and%20golden%20amber%20tones%2C%20clean%20composition%20on%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail&width=300&height=400&seq=rank-manga-05&orientation=portrait',
    imageAlt: '香香漫画 - 海贼王封面',
  },
  {
    rank: 6,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    heat: '8200万',
    tag: '和风战斗',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20samurai%20character%20with%20water%20breathing%20effect%2C%20warm%20coral%20and%20deep%20amber%20tones%2C%20clean%20composition%20on%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail&width=300&height=400&seq=rank-manga-06&orientation=portrait',
    imageAlt: '香香漫画 - 鬼灭之刃封面',
  },
  {
    rank: 7,
    title: '排球少年',
    author: '古馆春一',
    heat: '7500万',
    tag: '运动热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20sports%20volleyball%20character%20with%20dynamic%20action%20pose%2C%20warm%20coral%20and%20amber%20tones%2C%20clean%20composition%20on%20simple%20background%2C%20professional%20manga%20cover%20design%2C%20high%20detail&width=300&height=400&seq=rank-manga-07&orientation=portrait',
    imageAlt: '香香漫画 - 排球少年封面',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">香香漫画全网热度排行榜，看看大家都在追什么</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-3 md:gap-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 p-3 md:p-4 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base shrink-0 ${
                item.rank <= 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="w-12 h-16 md:w-14 md:h-20 rounded-lg overflow-hidden shrink-0">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap">{item.title}</h3>
                  <span className="text-[10px] md:text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.author} 著</p>
              </div>

              <div className="text-right shrink-0">
                <div className="text-sm md:text-base font-heading font-bold text-accent-600">{item.heat}</div>
                <div className="text-[10px] md:text-xs text-foreground-500">热度</div>
              </div>

              <div className="hidden sm:flex items-center gap-1 text-primary-600 font-medium text-sm whitespace-nowrap shrink-0">
                阅读 <i className="ri-arrow-right-s-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}